// src/services/bookingRequestService.js
// 待回撥訂位 — Admin API 客戶端（feature_plans/115 Phase C）
// 對應後端 /api/booking-requests（JWT，company 由 token 決定）。
// 一律 return res.data —— apiRequest 回的是原始 axios response（gotcha #9）。
import apiService from './apiService';

const { apiRequest } = apiService;

// GET /api/booking-requests?status=open|all → { success, openCount, data:[…] }
const list = async ({ status = 'open' } = {}) => {
  const res = await apiRequest('get', `booking-requests?status=${encodeURIComponent(status)}`);
  return res.data;
};

// PATCH /api/booking-requests/:id/resolve
//   body: { outcome: 'booked'|'no_deal'|'no_answer'|'ignored', reservationId?, memo? }
//   outcome='booked' 時 reservationId 必填 → { success, id, status }
const resolve = async (id, payload) => {
  const res = await apiRequest('patch', `booking-requests/${encodeURIComponent(id)}/resolve`, payload);
  return res.data;
};

const bookingRequestService = { list, resolve };
export default bookingRequestService;
